import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 1.5rem;
  text-align: center;
  color: #212121;
  margin-bottom: 1em;
  margin: 1rem;

  @media (max-width: 700px) {
    font-size: 1rem;
  }

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 1rem;

  .result {
    font-weight: bold;
    margin-top: 1rem;
  }
`;
